import { Icon } from '@iconify/react';
import { Card, CardBody } from '@nextui-org/react';
import { useTranslation } from 'common/src/hooks/useTranslation';
import { KpiCard } from '../ui';
import type { PulseData } from '../../utils/industry-volume/build-pulse';
import { mkg, pct, seasonShort, signedPct, week } from './format';

// Lo que trae el módulo completo, para mostrar qué se desbloquea.
const LOCKED = [
  'Tu volumen, tu ranking y tu market share contra la industria',
  'Curva de la temporada por semana, comparada con temporadas anteriores',
  'Mix de variedades de la industria y el tuyo',
  'Ranking de exportadoras: volumen, crecimiento, share ganado, aéreo y por variedad',
  'Mercados y países de destino',
  'Naves y arribos: cuánto viene en camino, cuándo y a qué puerto',
];

/** Sin suscripción a ASOEX: los totales de la industria y lo demás bloqueado. */
export default function PulsePreview({ data }: { data: PulseData }) {
  const { t } = useTranslation('volume');
  const industry = data.industry;
  const cur = industry?.cur ?? 0;
  const prev = industry?.prev ?? 0;
  const prevTotal = industry?.prev_total ?? 0;

  return (
    <div className='flex flex-col gap-4'>
      <div className='grid grid-cols-1 gap-4 md:grid-cols-2'>
        <KpiCard
          label={t('Industria a la sem {{week}}', { week: week(data.cutoff_week) })}
          value={`${mkg(cur)} M kg`}
          detail={t('{{growth}} vs {{prev}} · {{progress}} de lo que cerró {{prev}} ({{total}} M kg)', {
            growth: signedPct(prev ? cur / prev - 1 : null),
            prev: seasonShort(data.prev_season),
            progress: pct(prevTotal ? cur / prevTotal : null, 0),
            total: mkg(prevTotal),
          })}
        />
        <KpiCard
          label={t('Exportadoras con zarpes')}
          value={String(industry?.exporters ?? 0)}
          detail={t('a la semana {{week}} de {{season}}', { week: week(data.cutoff_week), season: data.season })}
        />
      </div>
      <Card shadow='sm'>
        <CardBody className='items-center gap-3 p-8 text-center'>
          <Icon icon='tabler:lock' width={28} className='text-default-400' />
          <h3 className='text-lg font-semibold'>
            {t('El detalle de Volumen es para exportadoras suscritas a ASOEX')}
          </h3>
          <ul className='flex flex-col gap-1 text-sm text-default-500'>
            {LOCKED.map((item) => (
              <li key={item}>{t(item)}</li>
            ))}
          </ul>
          <p className='max-w-xl text-sm'>
            {t('Para verlo, contrata la base de exportaciones con ASOEX y avísanos para activarlo en tu cuenta.')}
          </p>
        </CardBody>
      </Card>
    </div>
  );
}
